import React from 'react';
import { twMerge } from 'tailwind-merge';

export function IconCloseButton({ onClick, className, color = '#000' }) {
  return (
    <svg
      onClick={onClick}
      className={twMerge(' w-6 h-6 group', className)}
      fill="none"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 6L6 18M6 6L18 18"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
}
